import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../Core/Container';
import topCircle from '../../../images/pco-circle-top.svg';
import bottomCircle from '../../../images/pco-circle-bottom.svg';

export const Wrapper = styled.div`
  position: relative;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &::before {
      position: absolute;
      content: '';
      top: -10%;
      left: 0;
      background-image: url(${topCircle});
      background-size: contain;
      background-repeat: no-repeat;
      width: 175px;
      height: 100%;
    }
    &::after {
      position: absolute;
      content: '';
      right: 0%;
      bottom: -10%;
      background-image: url(${bottomCircle});
      background-size: contain;
      background-repeat: no-repeat;
      width: 100px;
      height: 194px;
    }
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    &::before {
      top: -12.5%;
      width: 200px;
    }
    &::after {
      width: 100px;
      height: 194px;
    }
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    &::before {
      top: -15%;
      width: 250px;
    }
    &::after {
      right: 0%;
      width: 120px;
      height: 225px;
    }
  }
`;

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h2`
  text-align: center;
  margin: 0 auto 20px;
`;

export const Subtitle = styled.div`
  text-align: center;
  margin: auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 70%;
  }
`;
